// extracted by mini-css-extract-plugin
export default {"AIGBanner":"AlertBanner_AIGBanner__7NA10","closeBanner":"AlertBanner_closeBanner__qLNUB"};